// Único punto de lectura de import.meta.env. El resto del código consume
// AppConfig, nunca el env directo.

export const AppConfig = {
  app: {
    name: import.meta.env.VITE_APP_NAME || "Claves Celular",
    version: import.meta.env.VITE_APP_VERSION || "2.0.0",
    environment: import.meta.env.VITE_APP_ENV || "development",
  },

  api: {
    cacheEnabled: import.meta.env.VITE_API_CACHE_ENABLED === "true",
    isLocal: import.meta.env.VITE_API_LOCAL === "true",
    localUrl: import.meta.env.VITE_API_LOCAL_URL || "http://localhost:5012",
    baseUrl: import.meta.env.VITE_API_BASE_URL || "https://api-clavescelular.casadelaudio.com",
    timeout: Number.parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
    retryAttempts: Number.parseInt(import.meta.env.VITE_API_RETRY_ATTEMPTS) || 3,
  },

  lcapii: {
    url: import.meta.env.VITE_LCAPII_URL || "https://lcapii.casadelaudio.com",
    sid: import.meta.env.VITE_LCAPII_SID || "3",
    skipLogin: import.meta.env.VITE_LCAPII_SKIP_LOGIN === "true",
  },

  sesion: {
    // Ventana en la que se puede seguir operando sin contactar a LCApii, solo
    // ante fallas de red. Un 401 manda al login sin gracia.
    graciaOfflineMs:
      (Number.parseInt(import.meta.env.VITE_GRACIA_OFFLINE_HORAS) || 12) * 60 * 60 * 1000,
  },

  vacaciones: {
    // Secreto compartido con el backend del sistema de vacaciones: con él se
    // genera el código de habilitación. Sin secreto la operación no opera.
    secreto: import.meta.env.VITE_VACACIONES_SECRETO || "",
  },

  features: {
    debug: import.meta.env.VITE_ENABLE_DEBUG === "true",
  },

  isDevelopment: () => AppConfig.app.environment === "development",
  isProduction: () => AppConfig.app.environment === "production",
};
